import React from "react";
import { Link } from "react-router-dom";
import AuxiliaryText from "../Typography/AuxiliaryText";

export const PROFILE_SPECIALTY_CHIPS = [
  "Gasfitting",
  "Drainage",
  "Roof Plumbing",
];

export const SPECIALTY_CHIP =
  "post-detail-specialty-chip group inline-flex items-center border border-solid border-mediumgray rounded-[4px] px-2 py-1 whitespace-nowrap hover:bg-offblack hover:border-offblack transition-all duration-200";

export const SPECIALTY_CHIP_CLASS = SPECIALTY_CHIP;

const ProfileSpecialtyChips = ({
  specialties = PROFILE_SPECIALTY_CHIPS,
  categoryPath = "/category/plumbing",
  className = "flex flex-wrap items-center justify-center gap-2",
  linked = true,
}) => {
  return (
    <div className={className}>
      {specialties.map((specialty) => {
        const chip = (
          <span className={SPECIALTY_CHIP}>
            <AuxiliaryText
              variant="CtaChip"
              className="text-offblack group-hover:text-white"
            >
              {specialty}
            </AuxiliaryText>
          </span>
        );

        if (linked) {
          return (
            <Link key={specialty} to={categoryPath}>
              {chip}
            </Link>
          );
        }

        return <span key={specialty}>{chip}</span>;
      })}
    </div>
  );
};

export default ProfileSpecialtyChips;
